import { message } from 'antd'

const Message = (text, type = 'info', duration = 1.5) => {
  message[type](text, duration)
}

export default Message
